import { memo, useMemo } from "react";
import WindowControl from "./WindowControl";
import type { CarWindow } from "../types";

interface WindowsManagerProps {
  windows: CarWindow[];
  onWindowUp: (id: string) => void;
  onWindowDown: (id: string) => void;
  title?: string;
  subtitle?: string;
}

const WindowsManager = memo<WindowsManagerProps>(
  ({
    windows,
    onWindowUp,
    onWindowDown,
    title = "Windows Management",
    subtitle = "Window name",
  }) => {
    const controls = useMemo(
      () =>
        windows.map((w) => (
          <WindowControl
            key={w.id}
            name={w.name}
            isOpen={w.isOpen}
            onUp={() => onWindowUp(w.id)}
            onDown={() => onWindowDown(w.id)}
          />
        )),
      [windows, onWindowUp, onWindowDown],
    );

    return (
      <div className="bg-[#0b0c0c]/40 border-[1px] border-white/[0.06] p-3 rounded-xl">
        <div className="mb-3">
          <h3 className="text-white text-[17px] leading-tight">{title}</h3>
        </div>

        <div className="flex gap-4">{controls}</div>
      </div>
    );
  },
);

WindowsManager.displayName = "WindowsManager";
export default WindowsManager;
